import React, { useEffect, useState } from "react";
import AgentForm from "./AgentForm";
import { Pencil, Trash2, Plus } from "lucide-react";

const apiBaseURL = process.env.REACT_APP_BACKEND_API_URL;

const AgentsAdmin = () => {
  const [agents, setAgents] = useState([]);
  const [editingAgent, setEditingAgent] = useState(null);
  const [formOpen, setFormOpen] = useState(false);

  // Fetch all agents
  const fetchAgents = async () => {
    try {
      const res = await fetch(`${apiBaseURL}/agents`);
      if (!res.ok) throw new Error("Failed to fetch agents");
      const data = await res.json();
      setAgents(
        data.sort(
          (a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
        )
      );
    } catch (error) {
      console.error("Error fetching agents:", error);
    }
  };

  useEffect(() => {
    fetchAgents();
  }, []);

  // Delete agent
  const deleteAgent = async (id) => {
    if (!window.confirm("Delete this agent?")) return;
    await fetch(`${apiBaseURL}/agents/${id}`, { method: "DELETE" });
    fetchAgents();
  };

  return (
    <div className="container mx-auto font-gotham">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold">Agents Admin</h1>
        <button
          className="flex items-center gap-2 bg-teal-600 hover:bg-teal-700 text-white px-4 py-2 rounded-md text-sm"
          onClick={() => {
            setEditingAgent(null);
            setFormOpen(true);
          }}
        >
          <Plus className="w-4 h-4" />
          Add Agent
        </button>
      </div>

      {/* Agents Table */}
      <div className="overflow-x-auto bg-white rounded-lg shadow-lg border border-gray-200">
        <table className="table-auto w-full text-sm text-gray-700">
          <thead className="bg-teal-50 text-gray-800">
            <tr>
              <th className="px-6 py-3 text-left font-semibold">Name</th>
              <th className="px-6 py-3 text-left font-semibold">Description</th>
              <th className="px-6 py-3 text-left font-semibold">Created</th>
              <th className="px-6 py-3 text-left font-semibold">Actions</th>
            </tr>
          </thead>
          <tbody>
            {agents.map((agent) => (
              <tr key={agent.id} className="hover:bg-gray-100 border-t">
                <td className="px-6 py-4">{agent.name}</td>
                <td className="px-6 py-4">{agent.description || "-"}</td>
                <td className="px-6 py-4">
                  {new Date(agent.created_at).toLocaleString()}
                </td>
                <td className="px-6 py-4 flex gap-3">
                  <button
                    className="text-yellow-600 hover:text-yellow-700"
                    onClick={() => {
                      setEditingAgent(agent);
                      setFormOpen(true);
                    }}
                  >
                    <Pencil className="w-5 h-5" />
                  </button>
                  <button
                    className="text-red-600 hover:text-red-700"
                    onClick={() => deleteAgent(agent.id)}
                  >
                    <Trash2 className="w-5 h-5" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Form Modal */}
      {formOpen && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center">
          <div className="bg-white p-6 rounded-lg shadow-lg w-[500px] space-y-4 border border-gray-200">
            <AgentForm
              agent={editingAgent}
              onClose={() => setFormOpen(false)}
              onSaved={() => {
                setFormOpen(false);
                fetchAgents();
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default AgentsAdmin;
